import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "v-text-field__d etails" }
const _hoisted_2 = { class: "v-messages theme--light" }
const _hoisted_3 = { class: "v-messages__wrapper error--text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MazPhoneNumberInput = _resolveComponent("MazPhoneNumberInput")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'phone-input': true,'error--text': _ctx.error,'phone-input--outlined': _ctx.outlined })
  }, [
    _createElementVNode("div", null, [
      _createVNode(_component_MazPhoneNumberInput, {
        ref: "phoneInput",
        modelValue: _ctx.phoneNumber,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.phoneNumber) = $event)),
        "default-country-code": "US",
        "no-example": "",
        error: _ctx.error,
        onUpdate: _ctx.update,
        class: _normalizeClass({'phone-input-auto-width': !_ctx.showIcon})
      }, null, 8, ["modelValue", "error", "onUpdate", "class"]),
      (_ctx.showIcon)
        ? (_openBlock(), _createBlock(_component_v_icon, {
            key: 0,
            icon: "phone",
            style: {"margin-left":"0.9rem","margin-top":"0.7rem","color":"grey"}
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.errorMessages), 1)
      ])
    ])
  ], 2))
}